import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import RolesList from './RolesList';
import RoleCreate from './RoleCreate';
import RoleEdit from './RoleEdit';

function Roles() {
  return (
    <Routes>
      <Route path="/" element={<RolesList />} />
      <Route path="/create" element={<RoleCreate />} />
      <Route path="/edit/:id" element={<RoleEdit />} />
      <Route path="*" element={<Navigate to="/roles" replace />} />
    </Routes>
  );
}

export default Roles;